export default "__VITE_ASSET__BNReRf3W__"